// 套餐子項（comboMode 0）選取結果的共用讀取
// 可重複選（allowSelectManyTimes）：每份一筆 orderProducts，各自帶規格（與 POS 一致）
// 其餘：沿用 productSelectCount 對應 products + markUpProducts 的接續編號
export function getComboSubSelections(group) {
  if (
    group?.allowSelectManyTimes &&
    Object.prototype.hasOwnProperty.call(group, "orderProducts")
  ) {
    if (!Array.isArray(group.orderProducts))
      throw new Error("套餐選取資料不完整，請重新選餐");
    return group.orderProducts.map((product) => ({ product, count: 1 }));
  }
  const products = (group?.products || []).concat(group?.markUpProducts || []);
  return (group?.productSelectCount || [])
    .map((count, index) => ({ count, product: products[index] }))
    .filter(({ count, product }) => count > 0 && product);
}

// 單一子項商品的規格加價（一份）
export function getProductSpecPrice(product) {
  return (product?.productSpecSettings || []).reduce((total, spec) => {
    return (
      total +
      (spec.subSpecOptionSelectCount || []).reduce((sum, count, index) => {
        const option = spec.specOptions?.[index];
        return count && option ? sum + count * option.price : sum;
      }, 0)
    );
  }, 0);
}

export function validateRepeatComboGroup(group) {
  if (!group?.allowSelectManyTimes) return;
  // 只有真正缺少欄位的歷史購物車走舊路徑；null 或錯誤型別不可當舊資料。
  if (!Object.prototype.hasOwnProperty.call(group, "orderProducts")) return;
  const fail = () => {
    throw new Error("套餐選取資料不完整，請移除後重新選餐");
  };
  const products = [
    ...(group.products || []),
    ...(group.markUpProducts || []),
  ];
  const counts = group.productSelectCount;
  if (
    !Array.isArray(group.orderProducts) ||
    !Array.isArray(counts) ||
    counts.length !== products.length
  )
    fail();
  const actual = products.map(() => 0);
  const keys = new Set();
  for (const product of group.orderProducts) {
    const index = products.findIndex(
      (p) => String(p.id).trim() === String(product?.id).trim()
    );
    if (
      index < 0 ||
      !product.orderProductKey ||
      keys.has(product.orderProductKey)
    )
      fail();
    keys.add(product.orderProductKey);
    actual[index]++;
    const expectedSpecs = products[index].productSpecSettings || [];
    const specs = product.productSpecSettings;
    if (!Array.isArray(specs) || specs.length !== expectedSpecs.length) fail();
    for (let i = 0; i < specs.length; i++) {
      const spec = specs[i];
      const expected = expectedSpecs[i];
      if (String(spec.subSpecID).trim() !== String(expected.subSpecID).trim())
        fail();
      const selected = spec.subSpecOptionSelectCount;
      const options = spec.specOptions || [];
      if (
        !Array.isArray(selected) ||
        selected.length !== options.length ||
        selected.some((n) => !Number.isInteger(n) || n < 0)
      )
        fail();
      const total = selected.reduce((sum, n) => sum + n, 0);
      if (spec.mustHave && total === 0) fail();
      if (spec.isSingleSelection && total > 1) fail();
      if (!spec.allowSelectManyTimes && selected.some((n) => n > 1)) fail();
      if (
        !spec.isSingleSelection &&
        (total < spec.multiSelectionMin || total > spec.multiSelectionMax)
      )
        fail();
    }
  }
  if (
    counts.some(
      (n, i) => !Number.isInteger(n) || n < 0 || n !== actual[i]
    )
  )
    fail();
}
